export default __webpack_public_path__ + "a7cef04fdbc152ff604f54c409e4280d.svg";